<template>
    <v-app id="inspire">
        <v-app-bar
            :clipped-left="$vuetify.breakpoint.lgAndUp"
            app
            color="primary"
            dark
        >
<!--                  <v-app-bar-nav-icon @click.stop="drawer = !drawer" />-->

            <v-toolbar-title
                style="width: 350px"
            >
                <a href="/" class="white--text" style="text-decoration: none">
                    <v-icon>mdi-hammer-wrench</v-icon>&nbsp;Jaworowe.pl</a>
            </v-toolbar-title>
            <!--        <SearchBar/>-->
            <v-spacer/>

            <a href="tel:695628060" class="white--text" style="text-decoration: none">
                <v-icon>mdi-phone</v-icon>tel: 695-628-060</a>
        </v-app-bar>
        <v-content>
            <v-bottom-navigation
                :value="activeBtn"
                color="primary"
                horizontal
            >
                <v-btn href="/">
                    <span>Wypożyczalnia</span>
                </v-btn>
                <v-btn href="/regulamin">
                    <span>Regulamin</span>
                </v-btn>
                <v-btn href="/kontakt">
                    <span>Kontakt</span>
                </v-btn>
            </v-bottom-navigation>
            <router-view/>
        </v-content>
        <v-footer
            :padless="true"
        >
            <v-card
                flat
                tile
                width="100%"
                class="secondary white--text text-center"
            >
                <v-card-text class="white--text">
                    Wypożyczalnia sprzętu remontowo budowlanego<br>
                    tel: 695-628-060
                </v-card-text>

                <v-divider></v-divider>

                <v-card-text class="white--text">
                    {{ new Date().getFullYear() }} — <strong>ShipIT</strong>
                </v-card-text>
            </v-card>
        </v-footer>
    </v-app>
</template>
<script>
import SearchBar from "./Search/SearchBar";

export default {
    components: {SearchBar},

     data () {
         return {
    //         items: [
    //             { title: 'T-Shirts' },
    //             { title: 'Jackets' },
    //             { title: 'Shirts' },
    //             { title: 'Jeans' },
    //             { title: 'Shoes' },
    //         ],
              //activeBtn: 2,
         }
     }
}
</script>

<style>
.v-bottom-navigation a {
    padding: 0 20px;
}
.v-item-group.v-bottom-navigation .v-btn {
    font-size: 16px;

}
</style>




// WEBPACK FOOTER //
// src/components/Layout.vue